import * as api from "../../shared/api";
import apiPath from "../../shared/apiPath";
import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "PriceDiscTable";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const descriptor = {};
const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);
const fields = {
  default: [{
    key: "id",
    label: "编号",
    sortable: true
  },
  // { key: "Agreement", label: "价格协议" },
  {
    key: "dataAreaId",
    label: "公司"
  },
  {
    key: "CompanyName",
    label: "销售公司名称",
    sortable: true,
    thStyle: { width: "8rem" },
    width: "8rem",
    type: "short"
  },
  {
    key: "ItemRelation",
    label: "物料编号"
  },
  {
    key: "NameAlias",
    label: "物料名称",
    thStyle: {
      width: "15rem"
    }
  },
  {
    key: "VariantName",
    label: "变型名称",
    thStyle: {
      width: "10rem"
    }
  },
  {
    key: "AccountRelation",
    label: "供应商账户"
  },
  {
    key: "VendName",
    label: "供应商名称",
    thStyle: {
      width: "10rem"
    }
  },
  {
    key: "Amount",
    label: "价格",
    type: "number"
  },
  {
    key: "SEI_PriceCost",
    label: "成本",
    type: "number"
  },
  {
    key: "Currency",
    label: "币种"
  },
  {
    key: "DeliveryAddress",
    label: "送货地址"
  },
  {
    key: "QuantityAmountFrom",
    label: "数量(从)",
    type: "number"
  },
  {
    key: "QuantityAmountTo",
    label: "数量(到)",
    type: "number"
  },
  {
    key: "FromDate",
    label: "开始日期",
    type: "date"
  },
  {
    key: "ToDate",
    label: "结束日期",
    type: "date"
  },
  {
    key: "relation",
    label: "关系"
  },
  {
    key: "ItemCode",
    label: "物料代码"
  },
  {
    key: "AccountCode",
    label: "帐户编码"
  },
  {
    key: "JournalNum",
    label: "价格日记账号"
  },
  {
    key: "modifiedDateTime",
    label: "修改日期和时间",
    type: "datetime"
  }
  ]
};

const dataForm = {};

///前端验证
const rules = {};

const methods = {
  ///get
  async getData(_params) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_priceDiscPurchTableInfo", {}, {}
    );
    let result = await code_biz_data
      .execAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
    // let result = await biz_data
    //   .selectAction({
    //     params: _params,
    //     fields: _.map(fields.default, "key")
    //   })
    //   .run();
    //
    // if (
    //   result &&
    //   result[0].result &&
    //   result[0].result.data &&
    //   result[0].result.data.ActionResult &&
    //   result[0].result.data.ActionResult.Result &&
    //   result[0].result.data.ActionResult.Result.Data.length > 0
    // ) {
    //   return result[0].result.data.ActionResult.Result.Data;
    // } else {
    //   return null;
    // }
  },
  async pickAndInvoke(params) {
    let result = await api.query_async({
      url: apiPath.axInterface.pickand_invoke,
      parameters: params,
      method: "get"
    });
    if (
      result &&
      result[0] &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.length > 0 &&
      result[0].result.data[0].status == 0
    ) {
      return result[0].result.data[0].data;
    } else {
      return null;
    }
  }
};

export {
  biz_data, dataForm, fields,
  methods, rules
};

